export interface TutorialChapter {
  id: string;
  name: string;
  number: number;
  firstStepId: number;
  lastStepId: number;
  completionMessage?: string;
}

export const chapters: TutorialChapter[] = [
  {
    id: 'brain-basic',
    name: 'BRAIN Basics',
    number: 1,
    firstStepId: 0,
    lastStepId: 6,
    completionMessage:
      "Congratulations! You have learned how BRAIN works and mastered its basic features. Now, let's dive into what kinds of alphas you can create!",
  },
  {
    id: 'pv-alphas',
    name: 'PV Alphas',
    number: 2,
    firstStepId: 7,
    lastStepId: 12,
    completionMessage:
      "Congratulations! You have learned how to create alphas using price and volume data in BRAIN. Now, let's explore how to create alphas using fundamental data from company financial statements!",
  },
  {
    id: 'fundamental-alphas',
    name: 'Fundamental Alphas',
    number: 3,
    firstStepId: 13,
    lastStepId: 18,
    completionMessage:
      "Congratulations! You have mastered creating alphas using fundamental data. Now, let's learn how to capture alphas from options based on stocks!",
  },
  {
    id: 'option-alphas',
    name: 'Option Alphas',
    number: 4,
    firstStepId: 19,
    lastStepId: 22,
    completionMessage:
      "Congratulations! You have learned how to capture alphas from options trading. Now, let's explore alphas using data from news and social media!",
  },
  {
    id: 'sentiment-news-alphas',
    name: 'Sentiment & News Alphas',
    number: 5,
    firstStepId: 23,
    lastStepId: 25,
    completionMessage:
      "Congratulations! You have explored various alphas that can be found in BRAIN. Now, based on everything you've learned so far, let's submit alphas and take the next step to reach the consultant level, where you can utilize advanced features and diverse datasets.",
  },
  {
    id: 'completion',
    name: 'Completion',
    number: 6,
    firstStepId: 26,
    lastStepId: 26,
  },
];

export const stepToChapter = (stepId: number): TutorialChapter | null => {
  for (const chapter of chapters) {
    if (stepId >= chapter.firstStepId && stepId <= chapter.lastStepId) {
      return chapter;
    }
  }
  return null;
};
